<template>
  <div class="sp_step">
    <el-form :model="registerOneForm"
             :rules="registerOneRules"
             ref="registerOneForm"
             @submit.native.prevent>
      <el-form-item :label="$t('loginModule.email')+'：'"
                    prop="email"
                    style="position: relative;">
        <el-input v-model="registerOneForm.email"
                  type="text"></el-input>
        <span style="position: absolute; top:80px; left:0px; color: #e6a23c; line-height:15px; font-size:12px;"
              v-if="emailNotice !==''">{{emailNotice}}</span>
      </el-form-item>

      <el-form-item>
        <el-checkbox v-model="checkAgreement">{{$t('loginModule.agreement')}} <a href="javascript:void(0);"
             @click="showDialog">{{$t('loginModule.privacyPolicy')}}</a>.</el-checkbox>
        <el-button :loading="sendLoading"
                   :disabled="!checkAgreement||timeOut>0"
                   class="send-code-btn"
                   type="primary"
                   style="width:100%; height:48px;font-size:16px; margin-top:10px;"
                   @click="sendCode('registerOneForm')">{{timeOut>0?timeOut+'s':$t("loginModule.sendCode")}}</el-button>
        <p class="sp_register_skip">{{$t("loginModule.haveAccount")}}&nbsp;<router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
        </p>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import { registerCheckEmail, sendRegisterEmail } from '@/api/loginApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  components: {},
  name: 'registerOne',
  data() {
    var checkEmail = (rule, value, callback) => {
      this.emailNotice = ''
      const Reg =
        /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback(new Error('Please input email.'))
      } else {
        if (Reg.test(value)) {
          if (value.length > 255) {
            return callback(new Error('Cannot exceed over 255 characters.'))
          } else {
            this.registerOneForm.isPersonalMail = []
            registerCheckEmail(registerEncrypt(value)).then((res) => {
              if (res.code == 303) {
                this.emailNotice = res.msg
                callback()
              } else if (res.rows.length > 0) {
                this.registerOneForm.isPersonalMail = res.rows
                callback()
              } else if (res.code == 500) {
                this.emailNotice = ''
                callback(new Error(res.msg))
              } else {
                callback()
              }
            })
          }
        } else {
          return callback(
            new Error(
              'Your email format is wrong, please check and try it again.'
            )
          )
        }
      }
    }
    return {
      registerOneForm: {
        email: '',
        isPersonalMail: [],
      },

      registerOneRules: {
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }],
      },

      checkAgreement: false,
      timeOut: 0,
      emailNotice: '',
      sendLoading: false,
    }
  },

  methods: {
    showDialog() {
      this.$emit('showAgreement', true)
    },

    sendCode(registerOneForm) {
      this.$refs[registerOneForm].validate((valid) => {
        if (valid) {
          this.sendLoading = true
          let params = registerEncrypt(this.registerOneForm.email)
          sendRegisterEmail(params)
            .then(() => {
              this.sendLoading = false
              this.$message({
                type: 'success',
                message: 'Send successfully',
              })
              this.$emit('registerOne', {
                params: this.registerOneForm,
                isNext: true,
              })
            })
            .catch(() => {
              this.sendLoading = false
            })
        }
      })
    },

    //倒计时
    countDown() {
      const timeNum = 59
      let timer = setInterval(() => {
        if (this.timeOut > 0 && this.timeOut <= timeNum) {
          this.timeOut--
          this.$ls.set('reTimeOut', this.timeOut)
        } else {
          clearInterval(timer)
          this.timer = null
        }
      }, 1000)
    },
  },

  created() {
    let timeNum = this.$ls.get('reTimeOut')
    if (timeNum) {
      this.timeOut = timeNum
      this.countDown()
    }
  },
}
</script>

<style lang="scss" scoped>
.sp_step {
  .el-form::-webkit-scrollbar {
    /*隐藏滚动条*/
    display: none;
  }
}

/deep/.el-checkbox__label {
  font-size: 14px;
  font-weight: 400;
  color: #333940;
}
</style>

